import { apiFetch } from "./apiClient";

export const login = async ({ email, password }) =>
  apiFetch("/api/auth/login", {
    method: "POST",
    body: { email, password },
  });

export const signup = async ({ email, password, profile }) =>
  apiFetch("/api/auth/signup", {
    method: "POST",
    body: { email, password, profile },
  });

export const magicLink = async ({ email, profile }) =>
  apiFetch("/api/auth/magic", {
    method: "POST",
    body: { email, profile },
  });

export const logout = async () =>
  apiFetch("/api/auth/logout", { method: "POST" });

export const getSession = async () => apiFetch("/api/auth/session");

export const bootstrap = async () => apiFetch("/api/bootstrap");

export const diagnoseAndFixWorkspaces = async () =>
  apiFetch("/api/workspaces/diagnose-and-fix", { method: "POST" });

// ── Google OAuth ────────────────────────────────────────────────────────────

export const buildGoogleOAuthUrl = () => {
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
  const redirectUri = import.meta.env.VITE_GOOGLE_REDIRECT_URI || "http://localhost:5173/auth/google/callback";
  if (!clientId) return null;
  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: "code",
    scope: "openid email profile",
    access_type: "offline",
    prompt: "select_account",
  });
  return `https://accounts.google.com/o/oauth2/v2/auth?${params}`;
};

export const googleCallback = async (code) =>
  apiFetch("/api/auth/google/callback", {
    method: "POST",
    body: { code },
  });
